import styled from 'styled-components';
import bgModalImg from 'assets/images/bg-modal-autenticar.png';

export const Container = styled.div`
  .bg-modal {
    background: url('${bgModalImg}') no-repeat 95% center;
    background-size: 48%;

    @media only screen and (max-width: 368px) {
      background: none;
    }
  }
  .font-scale {
    font-size: 1.05rem;
  }

  .close {
    position: absolute;
    right: 10px;
    top: 5px;
  }

  .badge-new {
    color: ${(props) => props.theme.$black};
    background: ${(props) => props.theme.$warning};
  }

  .text-green {
    color: ${(props) => props.theme.$medium_green};
  }
`;
